import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { track } from "@/lib/analytics";
import { useIsMobile } from "@/hooks/use-mobile";
import { MobileNavigation } from "@/components/mobile/MobileNavigation";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuTrigger, NavigationMenuContent, NavigationMenuLink } from "@/components/ui/navigation-menu";
import { Phone, Mail, Sun, BatteryCharging, Droplet, Car, Lightbulb, Package, Wrench, ThermometerSun, Snowflake, Home, Calculator, FileText, CheckSquare } from "lucide-react";
export function Header() {
  const isMobile = useIsMobile();
  return <header className="sticky top-0 z-50 bg-background/95 backdrop-blur-md border-b border-border supports-[backdrop-filter]:bg-background/95">
      <div className="container mx-auto px-4">
        {/* Top contact bar - Desktop only */}
        <div className="hidden lg:flex justify-end items-center py-2 text-sm text-muted-foreground border-b border-border/50">
          <div className="flex items-center gap-6">
            <a href="tel:0617105786" className="flex items-center gap-1 hover:text-primary transition-colors">
              <Phone className="h-3 w-3" />
              06 17 10 57 86
            </a>
            <a href="mailto:info@sol-vi.nl" className="flex items-center gap-1 hover:text-primary transition-colors">
              <Mail className="h-3 w-3" />
              info@sol-vi.nl
            </a>
          </div>
        </div>
        
        {/* Main navigation */}
        <div className="flex items-center justify-between py-3 md:py-4">
          <Link to="/" className="flex items-center" onClick={() => track("logo_click")}>
            <span className="text-xl md:text-2xl lg:text-3xl font-bold text-primary">
              Home
            </span>
          </Link>
          
          <nav className="hidden md:flex items-center gap-6">
            <NavigationMenu>
              <NavigationMenuList>
                <NavigationMenuItem>
                  <NavigationMenuTrigger className="text-sm">Diensten</NavigationMenuTrigger>
                  <NavigationMenuContent>
                    <div className="grid gap-3 p-6 md:w-[600px] lg:w-[700px] lg:grid-cols-2">
                      <NavigationMenuLink asChild>
                        <Link to="/zonnepanelen" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Zonnepanelen"
                      })}>
                          <Sun className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Zonnepanelen</div>
                            <p className="text-sm text-muted-foreground">Slimme PV-installaties met top rendement</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/warmtepompen" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Warmtepompen"
                      })}>
                          <ThermometerSun className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Warmtepompen</div>
                            <p className="text-sm text-muted-foreground">Efficiënte verwarming en koeling</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/airco" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Airco"
                      })}>
                          <Snowflake className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Airco</div>
                            <p className="text-sm text-muted-foreground">Koelen én verwarmen, fluisterstil</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/thuisbatterijen" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Thuisbatterijen"
                      })}>
                          <BatteryCharging className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Thuisbatterijen</div>
                            <p className="text-sm text-muted-foreground">Maximale zelfconsumptie en backup</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/zonneboilers" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Zonneboilers"
                      })}>
                          <Droplet className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Zonneboilers</div>
                            <p className="text-sm text-muted-foreground">Duurzaam warm water met de zon</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/elektra" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Elektra & Verlichting"
                      })}>
                          <Lightbulb className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Elektra & Verlichting</div>
                            <p className="text-sm text-muted-foreground">Veilige installatie en lichtplan</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/laadpalen" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Laadpalen"
                      })}>
                          <Car className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Laadpalen</div>
                            <p className="text-sm text-muted-foreground">Slim laden thuis en op de zaak</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/zonnepaneel-pakketten" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Pakketten"
                      })}>
                          <Package className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Pakketten</div>
                            <p className="text-sm text-muted-foreground">Vaste sets, helder geprijsd</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/smart-home" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Smart Home"
                      })}>
                          <Home className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Smart Home</div>
                            <p className="text-sm text-muted-foreground">Loxone domotica automatisering</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/maatwerk" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Maatwerk"
                      })}>
                          <Wrench className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Maatwerk</div>
                            <p className="text-sm text-muted-foreground">Ontwerp op maat voor uw situatie</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/isde-subsidie-calculator" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors bg-primary/5 border border-primary/20" onClick={() => track("nav_click", {
                        label: "Diensten - ISDE Calculator"
                      })}>
                          <Calculator className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">ISDE Subsidie Calculator</div>
                            <p className="text-sm text-muted-foreground">Bereken uw subsidie 2025</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/besparingscalculator" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors bg-primary/5 border border-primary/20" onClick={() => track("nav_click", {
                        label: "Diensten - Besparingscalculator"
                      })}>
                          <Calculator className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Besparingscalculator</div>
                            <p className="text-sm text-muted-foreground">Bereken uw energiebesparing</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/installatie-registreren" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Installatie Registreren"
                      })}>
                          <FileText className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Installatie Registreren</div>
                            <p className="text-sm text-muted-foreground">Aanmelden bij netbeheerder</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>

                      <NavigationMenuLink asChild>
                        <Link to="/opleverdocument" className="group flex items-start gap-3 rounded-md p-3 hover:bg-muted/50 transition-colors" onClick={() => track("nav_click", {
                        label: "Diensten - Opleverdocument"
                      })}>
                          <CheckSquare className="h-5 w-5 text-primary" />
                          <div>
                            <div className="font-medium">Opleverdocument</div>
                            <p className="text-sm text-muted-foreground">Conformiteitsverklaring installatie</p>
                          </div>
                        </Link>
                      </NavigationMenuLink>
                    </div>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>

            <Link to="/over-ons" className="text-foreground hover:text-primary transition-colors" onClick={() => track("nav_click", {
            label: "Over Ons"
          })}>
              Over Ons
            </Link>
            <Link to="/installatie-registreren" className="text-foreground hover:text-primary transition-colors" onClick={() => track("nav_click", {
            label: "Installatie Registreren"
          })}>
              Installatie Registreren
            </Link>
            <Link to="/contact" className="text-foreground hover:text-primary transition-colors" onClick={() => track("nav_click", {
            label: "Contact"
          })}>
              Contact
            </Link>
          </nav>

          {/* Mobile Navigation */}
          {isMobile ? <div className="flex items-center gap-2">
              <a href="tel:0617105786">
                <Button variant="ghost" size="icon" className="h-10 w-10" onClick={() => track("mobile_header_call")}>
                  <Phone className="h-4 w-4" />
                  <span className="sr-only">Bel direct</span>
                </Button>
              </a>
              <MobileNavigation />
            </div> : (/* Desktop CTAs */
        <div className="flex items-center gap-3">
              <Link to="/zonnepaneel-pakketten">
                <Button variant="outline" size="sm" className="hidden lg:inline-flex" onClick={() => track("nav_bereken_pakket")}>
                  Bereken Pakket
                </Button>
              </Link>
              <Button variant="cta" size="sm" onClick={() => {
            track("nav_calendly");
            (window as any).Calendly?.initPopupWidget?.({
              url: 'https://calendly.com/sol-vi/new-meeting?primary_color=ff7800',
              pageSettings: {
                backgroundColor: 'ffffff',
                hideEventTypeDetails: false,
                hideLandingPageDetails: false,
                primaryColor: 'ff7800',
                textColor: '4d5055'
              },
              prefill: {},
              utm: {}
            });
          }} className="text-center text-black bg-green-400 hover:bg-green-300">
                {isMobile ? "Advies" : "Plan Adviesgesprek"}
              </Button>
            </div>)}
        </div>
      </div>
    </header>;
}